<template>
    <div class="dialog update-age-dialog" @click.stop="">
        <b-form class="update-age-form">
            <div class="update-age-form-fields">
<!--                <div class="oocyte-age">-->
<!--                    <span class="label">-->
<!--                        <img class="age-icon" src="/static/svg/oocyte.svg" alt="" />-->
<!--                        {{ $translate('oocyte_age') }}-->
<!--                    </span>-->

<!--                    <b-form-input-->
<!--                        v-model="model.oocyteYears"-->
<!--                        type="number"-->
<!--                        :step="1"-->
<!--                        :min="minAge"-->
<!--                        :max="maxOocyteAge"-->
<!--                        placeholder="yy"-->
<!--                        class="rounded-1"-->
<!--                        :class="{ invalid: !oocyteAgeIsValid }"-->
<!--                    />-->
<!--                    <span class="point">.</span>-->
<!--                    <b-form-input-->
<!--                        v-model="model.oocyteMonths"-->
<!--                        type="number"-->
<!--                        :number="true"-->
<!--                        :min="0"-->
<!--                        :max="11"-->
<!--                        :step="1"-->
<!--                        placeholder="m"-->
<!--                        class="rounded-1"-->
<!--                        :class="{ invalid: !oocyteAgeIsValid }"-->
<!--                    />-->
<!--                </div>-->

                <div class="patient-age">
                    <span class="label">
                        <img class="age-icon" src="/static/svg/female.svg" alt="" />
                        {{ $translate('patient_age') }}
                    </span>

                    <b-form-input
                        v-model="model.patientYears"
                        type="number"
                        :step="1"
                        :min="minAge"
                        :max="maxPatientAge"
                        placeholder="yy"
                        class="rounded-1"
                    />
                    <span class="point">.</span>
                    <b-form-input
                        v-model="model.patientMonths"
                        type="number"
                        :number="true"
                        :min="0"
                        :max="11"
                        :step="1"
                        placeholder="m"
                        class="rounded-1"
                    />
                </div>
            </div>

            <div v-if="warningText" class="warning">
                <span>{{ warningText }}</span>
            </div>

            <div class="h-divider"></div>

            <div class="actions">
                <b-button class="cancel-btn" variant="link" @click.stop="hide">
                    {{ $translate('cancel') }}
                </b-button>

                <b-button
                    :disabled="!formIsValid"
                    class="submit-btn"
                    variant="primary"
                    @click="save"
                >
                    {{ $translate('save') }}
                </b-button>
            </div>
        </b-form>
    </div>
</template>

<script>
import UIUtils from '../../../business/utils/UIUtils'
import BackendProvider from '../../../business/services/BackendProvider'
import { mapState } from 'vuex'
import { ROUTES } from '../../../business/const'

export default {
    name: 'UpdateAgeDialog',
    props: {
        treatment: {
            type: Object,
            required: true
        },
        slideId: {
            type: String,
            default: null
        }
    },
    data() {
        return {
            model: {
                oocyteYears: this.getYears(this.treatment.oocyteAge),
                oocyteMonths: this.getMonthsRemainder(this.treatment.oocyteAge),
                patientYears: this.getYears(this.treatment.patientAge),
                patientMonths: this.getMonthsRemainder(this.treatment.patientAge)
            },
            minAge: 17,
            maxOocyteAge: 51,
            maxPatientAge: 90
        }
    },
    computed: {
        ...mapState({
            selectedTenant: state => state.common.selectedTenant
        }),
        oocyteAgeIsValid() {
            const { oocyteYears, oocyteMonths } = this.model
            const oocyteAgeMonths = this.getMonths(oocyteYears, oocyteMonths)

            return oocyteAgeMonths >= this.minAge * 12 && oocyteAgeMonths <= this.maxOocyteAge * 12
        },
        patientAgeIsValid() {
            const { patientYears, patientMonths } = this.model
            const patientAgeMonths = this.getMonths(patientYears, patientMonths)

            const isEmpty = !patientAgeMonths
            const isInRange =
                patientAgeMonths >= this.minAge * 12 && patientAgeMonths <= this.maxPatientAge * 12

            return isEmpty || isInRange
        },
        delta() {
            const delta = {}

            const { oocyteYears, oocyteMonths, patientYears, patientMonths } = this.model

            const oocyteAgeMonths = this.getMonths(oocyteYears, oocyteMonths)
            const patientAgeMonths = this.getMonths(patientYears, patientMonths)

            if (oocyteAgeMonths !== Math.floor(this.treatment.oocyteAge)) {
                delta.oocyteAge = oocyteAgeMonths
            }
            if (patientAgeMonths !== Math.floor(this.treatment.patientAge)) {
                delta.patientAge = patientAgeMonths
            }

            return Object.keys(delta).length ? delta : null
        },
        formIsValid() {
            return this.oocyteAgeIsValid && this.patientAgeIsValid && this.delta
        },
        warningText() {
            if (!this.delta) return ''

            if (!this.oocyteAgeIsValid) {
                return `${this.$translate('add_oocyte_age')} (${this.minAge} - ${
                    this.maxOocyteAge
                })`
            }
            if (this.delta.patientAge && !this.patientAgeIsValid) {
                return `${this.$translate('add_patient_age')} (${this.minAge} - ${
                    this.maxPatientAge
                })`
            }
            return ''
        }
    },
    watch: {
        'model.oocyteMonths'(newVal) {
            this.model.oocyteMonths = this.validateMonths(newVal)
        },
        'model.patientMonths'(newVal) {
            this.model.patientMonths = this.validateMonths(newVal)
        }
    },
    methods: {
        validateMonths(newVal) {
            const newValNum = Number(newVal)

            if (newValNum < 0) return 0
            if (newValNum > 11) return 11

            return Math.floor(newValNum)
        },
        getYears(ageInMonths) {
            if (!ageInMonths) return undefined

            return Math.floor(ageInMonths / 12)
        },
        getMonthsRemainder(ageInMonths) {
            if (!ageInMonths) return undefined

            return Math.floor(ageInMonths % 12)
        },
        getMonths(years, months) {
            if (!years && !months) return null

            return parseInt(years) * 12 + parseInt(months || '0')
        },
        async save() {
            UIUtils.showLoadingMask()

            await BackendProvider.updateTreatment(this.treatment._id, this.delta)

            if (this.$route.name === ROUTES.HOME_PAGE) {
                // update all slides in treatment
                await this.$store.dispatch('timelapse/updateTreatmentAge', {
                    treatmentId: this.treatment._id,
                    delta: this.delta
                })
            } else {
                this.$emit('ageUpdated', this.delta)
            }

            UIUtils.hideLoadingMask()
            this.hide()

            // UIUtils.toast(
            //     this.$translate('update_score_within_hour'),
            //     'primary',
            //     3000,
            //     'update-notification'
            // )
        },
        hide() {
            this.$emit('hide')
        }
    }
}
</script>

<style lang="scss" scoped>
.update-age-dialog {
    width: 20rem;
    display: flex;
    flex-direction: column;
    top: #{$sub-header-height + 0.1}; // todo: move to subheader usage
    background-color: $dark-4;
    color: $light-3;
    cursor: default;
    opacity: 1 !important;
    pointer-events: initial !important;

    .update-age-form {
        width: 100%;
        display: flex;
        flex-direction: column;

        .update-age-form-fields {
            display: flex;
            justify-content: space-between;
            padding: 0.5rem;

            .oocyte-age,
            .patient-age {
                width: 100%;
                display: flex;
                align-items: center;
                justify-content: center;
                @include input-number-no-arrows();

                .label {
                    white-space: initial;
                    font-size: 9pt;
                    font-weight: 500;
                    margin-right: 0.5rem;
                    display: flex;
                    align-items: center;

                    .age-icon {
                        height: 18px;
                        margin-right: 0.5rem;
                    }
                }

                input {
                    padding: 0.375rem 0.25rem;
                    text-align: center;
                    background-color: $light-3;
                    border: $border-narrow-dark;
                    font-size: 9pt;
                    font-weight: 500;
                    color: $dark-5;

                    &.invalid {
                        border: 0.1rem solid $red;
                    }
                }

                .point {
                    font-size: 18pt;
                }
            }
        }

        .warning {
            padding: 1rem;
            text-align: center;
            font-size: 9pt;
            color: $light;
        }

        .actions {
            width: 100%;
            padding: 0.5rem;
            display: flex;
            align-items: center;
            justify-content: space-between;

            .cancel-btn {
                color: $blue;
                font-weight: bold !important;
                padding: 0 0.5rem;
            }
            .submit-btn {
                font-weight: bold !important;
                padding: 0.375rem 3rem;

                &.disabled {
                    pointer-events: none;
                }
            }
        }
    }
}
</style>

<style lang="scss">
.update-notification {
    position: fixed;
    right: 0;
    left: 0;
    top: $header-height;

    .b-toast {
        max-width: unset;
        background-color: $dark-4;

        .toast {
            display: flex;
            justify-content: center;
            max-width: unset;
            border: solid 1px $blue;
            background-color: rgba($dark-blue, 0.1);
            color: $blue;
            border-radius: 0;
            font-size: 15px;
        }
    }
}
</style>
